import { Form } from '@ih/app/shared/apis/interfaces';

export class SetForms {
  public static readonly type = '[Project/Form/List] SetForms';
  constructor(public readonly forms: Form[]) {}
}
